const skeletonModule = {
    namespaced: true,

    state: {
        loadingStates: {}
    },

    mutations: {

        setLoadingState(state, { key, value }) {
            state.loadingStates[key] = value
        },

        setMultipleLoadingStates(state, states) {
            Object.keys(states).forEach(key => {
                state.loadingStates[key] = states[key]
            })
        },

        resetAllLoadingStates(state) {
            Object.keys(state.loadingStates).forEach(key => {
                state.loadingStates[key] = false
            })
        },

        resetViewLoadingStates(state, viewPrefix) {
            Object.keys(state.loadingStates).forEach(key => {
                if (key.startsWith(viewPrefix)) {
                    state.loadingStates[key] = false
                }
            })
        }
    },

    actions: {
        setLoadingState({ commit }, payload) {
            commit('setLoadingState', payload)
        },

        setMultipleLoadingStates({ commit }, states) {
            commit('setMultipleLoadingStates', states)
        },

        resetAllLoadingStates({ commit }) {
            commit('resetAllLoadingStates')
        },

        resetViewLoadingStates({ commit }, viewPrefix) {
            commit('resetViewLoadingStates', viewPrefix)
        },
    },

    getters: {
        getSkeletonLoadingState: (state) => (key) => {
            return state.loadingStates[key] || false
        },

        getAllSkeletonStates: (state) => state.loadingStates,

        hasAnySkeletonLoading: (state) => {
            return Object.values(state.loadingStates).some(value => value === true)
        },

        getSkeletonStatesByView: (state) => (viewPrefix) => {
            const viewStates = {}
            Object.keys(state.loadingStates).forEach(key => {
                if (key.startsWith(viewPrefix)) {
                    viewStates[key] = state.loadingStates[key]
                }
            })
            return viewStates
        }
    }
};

export default skeletonModule;
